export const HEADER = 'Legal Terms';

export const SCALING = {
  TABLET: 1.6,
  DESKTOP: 2.0
};